export function telHref(phone: string): string | null {
  const dialable = phone.replace(/[^\d+]/g, '');
  return dialable.replace(/\D/g, '').length >= 6 ? `tel:${dialable}` : null;
}

export function whatsAppHref(phone: string): string | null {
  const digits = phone.replace(/\D/g, '');
  return digits.length >= 6 ? `https://wa.me/${digits}` : null;
}
